/**
 * דף קביעת תורים (business-sites): זיהוי מכשיר, הדגשת חנות מתאימה, קישורי App Store / Google Play.
 */
(function () {
  "use strict";

  /**
   * @returns {'ios' | 'android' | 'other'}
   */
  function detectPlatform() {
    var ua = navigator.userAgent || "";
    if (/Android/i.test(ua)) return "android";
    if (/iPad|iPhone|iPod/i.test(ua)) return "ios";
    if (
      typeof navigator.platform === "string" &&
      navigator.platform === "MacIntel" &&
      navigator.maxTouchPoints > 1
    ) {
      return "ios";
    }
    return "other";
  }

  function applyStoreHref(anchor, url) {
    if (!anchor) return;
    var trimmed = (url || "").trim();
    if (trimmed) anchor.setAttribute("href", trimmed);
  }

  function resetButtonStyles(iosBtn, androidBtn) {
    var btns = [iosBtn, androidBtn];
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      if (!b) continue;
      b.classList.remove(
        "btn-primary",
        "btn-dark",
        "text-white",
        "btn-outline-primary",
        "btn-outline-secondary",
        "btn-outline-dark"
      );
      b.classList.add("btn-outline-dark");
    }
  }

  function styleForPlatform(platform, iosBtn, androidBtn) {
    resetButtonStyles(iosBtn, androidBtn);
    if (platform === "ios" && iosBtn && androidBtn) {
      iosBtn.classList.remove("btn-outline-dark");
      iosBtn.classList.add("btn-dark", "text-white");
      androidBtn.classList.remove("btn-outline-dark");
      androidBtn.classList.add("btn-outline-secondary");
    } else if (platform === "android" && iosBtn && androidBtn) {
      androidBtn.classList.remove("btn-outline-dark");
      androidBtn.classList.add("btn-dark", "text-white");
      iosBtn.classList.remove("btn-outline-dark");
      iosBtn.classList.add("btn-outline-secondary");
    }
  }

  function hintText(platform) {
    if (platform === "ios") {
      return "זיהינו מכשיר Apple — מומלץ להוריד מחנות האפליקציות של אפל. ניתן לבחור גם את Google Play.";
    }
    if (platform === "android") {
      return "זיהינו מכשיר Android — מומלץ להוריד מ-Google Play. ניתן לבחור גם את חנות אפל.";
    }
    return "לא זיהינו מכשיר נייד ספציפי — בחרו את החנות המתאימה למכשיר שלכם (iPhone או Android).";
  }

  function initAppointmentPageStores() {
    var root = document.querySelector(".br-appt__download");
    if (!root) return;

    var iosBtn = root.querySelector(".br-appt__btn--ios");
    var androidBtn = root.querySelector(".br-appt__btn--android");
    var hintEl = root.querySelector(".br-appt__hint");

    var iosUrl = root.getAttribute("data-ios-url") || "";
    var androidUrl = root.getAttribute("data-android-url") || "";
    applyStoreHref(iosBtn, iosUrl);
    applyStoreHref(androidBtn, androidUrl);

    var platform = detectPlatform();
    if (hintEl) {
      hintEl.textContent = hintText(platform);
    }
    styleForPlatform(platform, iosBtn, androidBtn);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAppointmentPageStores, { once: true });
  } else {
    initAppointmentPageStores();
  }
})();
